import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputHTMLAttributes, useState } from 'react';
import { tss } from 'tss-react';

interface Props extends InputHTMLAttributes<unknown> {
	value: number;
	setValue: (input: number) => void;
	className?: string;
}

export default function InputNumber({ size, value, setValue, className, ...props }: Props) {
	const { classes } = useStyles();
	const [tempValue, setTempValue] = useState<string>(String(value));

	function isValid(newValue: number): boolean {
		if (Number.isNaN(newValue)) return false;
		if (props.min !== undefined) {
			if (newValue < Number(props.min)) return false;
		}
		if (props.max !== undefined) {
			if (newValue > Number(props.max)) return false;
		}
		return true;
	}

	function onBlur(): void {
		const newValue: number = Number(tempValue);
		if (isValid(newValue)) {
			setValue(newValue);
		} else {
			setTempValue(String(value));
		}
	}

	const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
		if (e.key !== 'Enter') return;
		onBlur();
	};

	function onChange(e: React.ChangeEvent<HTMLInputElement>): void {
		setTempValue(e.target.value);
	}

	function onClickUp() {
		const newValue = value + 1;
		if (!isValid(newValue)) return;
		setValue(newValue);
		setTempValue(String(newValue));
	}

	function onClickDown() {
		const newValue = value - 1;
		if (!isValid(newValue)) return;
		setValue(newValue);
		setTempValue(String(newValue));
	}

	return (
		<div className={classes.container}>
			<input
				className={
					className ? ['form-control', className].join(' ') : ['form-control'].join(' ')
				}
				{...props}
				type="string"
				value={tempValue}
				onBlur={onBlur}
				onChange={onChange}
				onKeyDown={onKeyDown}
			/>
			<div className={classes.caretContainer} onClick={onClickUp}>
				<FontAwesomeIcon icon={faCaretUp} />
			</div>
			<div className={classes.caretContainer} onClick={onClickDown}>
				<FontAwesomeIcon icon={faCaretDown} />
			</div>
		</div>
	);
}

const useStyles = tss.create({
	container: {
		display: 'flex',
	},
	caretContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: '#888',
		backgroundColor: '#e9ecef',
		border: '1px solid #ddd',
		width: '40px',
		transition: 'background-color 0.35s, color 0.35s',
		'&:hover': {
			backgroundColor: '#ddd',
			color: '#333',
		},
	},
});
